import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { saveGlobalClick } from "../../redux/actions/auditActions";
import { v4 as uuidv4 } from "uuid";
import { logError } from "../../redux/actions";
import { SILENT_ERROR } from "./ErrorConstants";

const GlobalErrorHandler = ({ children }) => {
    const dispatch = useDispatch();

    const onGlobalClick = (e) => {
        const clickDetails = {
            target: e.target.tagName,
            innerText: e.target.innerText,
            className: e.target.className,
        };
        dispatch(saveGlobalClick(clickDetails));
    };

    const onUnhandledError = (e) => {
        const uuid = uuidv4();

        const errorMetadata = {
            message: e,
            stack: null,
            componentStack: null,
            url: window.location.href,
            errorType: SILENT_ERROR,
            uuid,
        };

        if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
            dispatch(logError(errorMetadata));
        }
    };

    useEffect(() => {
        window.onerror = onUnhandledError;
    });
    return <>{children}</>;
};

export default GlobalErrorHandler;
